import { render, staticRenderFns } from "./addTenant.vue?vue&type=template&id=1756b68c&"
import script from "./addTenant.vue?vue&type=script&lang=js&"
export * from "./addTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1756b68c')) {
      api.createRecord('1756b68c', component.options)
    } else {
      api.reload('1756b68c', component.options)
    }
    module.hot.accept("./addTenant.vue?vue&type=template&id=1756b68c&", function () {
      api.rerender('1756b68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/leaseContract/contractList/addTenant.vue"
export default component.exports